export default __webpack_public_path__ + "static/media/moss-in-flowers.95c95d87.jpg";